import React, { useState } from 'react';
import { IChoiceDegreeFinder } from '../../../models/choice-degree-finder/IChoiceDegreeFinder';
import styles from './choice-degree-finder.module.scss';
import InfoPopup from '../../atoms/info-popup/info-popup';
import Markdown from 'markdown-to-jsx';
import Link from 'next/link';
import ImageComponent from '../../atoms/image-component/image-component';

type Props = {
  choiceDegree: IChoiceDegreeFinder;
};

export default function ChoiceDegreeFinder({ choiceDegree }: Props) {
  const [boldPrerequisites, setBoldPrerequisites] = useState(null);
  const [boldOtherRequirements, setBoldOtherRequirements] = useState(null);
  const [prerequisitesContent, setPrerequisitesContent] = useState(null);
  const [otherRequirementContent, setOtherRequirementsContent] = useState(null);
  const setContent = (prerequisitesContent) => {
    setBoldPrerequisites('header-link-focus');
    const content = <Markdown>{prerequisitesContent}</Markdown>;
    setPrerequisitesContent(content);
  };
  const setOtherRequirementPopupContent = (otherRequirementContent) => {
    setBoldOtherRequirements('header-link-focus');
    const content = <Markdown>{otherRequirementContent}</Markdown>;
    setOtherRequirementsContent(content);
  };
  const closePrerequisitesPopup = () => {
    setBoldPrerequisites(null);
    setPrerequisitesContent(null);
  };
  const closeOtherRequirementsPopup = () => {
    setBoldOtherRequirements(null);
    setOtherRequirementsContent(null);
  };
  return (
    <div className='row'>
      <div className='col-lg-6'>
        <h4 className={`${styles[`header`]} mt-md-3 mt-0`}>{choiceDegree.programName}</h4>
        <h6 className={`${styles[`sub-header-sm`]} font-family-lato fw-normal mt-3 mb-0`}>
          Entry Route
        </h6>
        <h4 className={`${styles[`sub-header-link`]} font-family-lato fw-normal m-0 mt-1`}>
          {choiceDegree.choiceBrandProgramDisableCourseLink ? (
            choiceDegree.choiceBrandProgramName
          ) : (
            <Link
              href={`/universities/${choiceDegree.choiceBrandSlug}/courses/${choiceDegree.choiceBrandProgramSlug}`}
              target='_blank'
            >
              {choiceDegree.choiceBrandProgramName}
            </Link>
          )}
        </h4>
        <h6 className={`${styles[`sub-header-sm`]} mt-4 mb-0 font-family-lato fw-normal`}>
          Progression Requirements
        </h6>
        <h5 className={`${styles[`sub-header`]}  m-0 my-2 font-family-lato fw-normal`}>
          {choiceDegree.progressionRequirements && choiceDegree.choiceBrandCountryCode != 'US' && (
            <strong>Final Level:</strong>
          )}{' '}
          {choiceDegree.progressionRequirements}
        </h5>
        {choiceDegree.languageRequirements && (
          <h5 className={`${styles[`sub-header`]} m-0 my-4 font-family-lato fw-normal`}>
            <strong>English Level:</strong> {choiceDegree.languageRequirements}
          </h5>
        )}
        {choiceDegree.prerequisites && (
          <div className='mb-3'>
            <span
              onClick={() => setContent(choiceDegree.prerequisites)}
              className={`${styles[`header-link`]} mt-md-3 mt-0 ${styles[boldPrerequisites]}`}
            >
              Prerequisites
            </span>
          </div>
        )}
        {choiceDegree.otherRequirements && (
          <div className='mt-3'>
            <span
              onClick={() => setOtherRequirementPopupContent(choiceDegree.otherRequirements)}
              className={`${styles[`header-link`]}  mt-md-3 mt-0 ${styles[boldOtherRequirements]}`}
            >
              Additional Requirements
            </span>
          </div>
        )}
      </div>
      <div className='col-lg-6 position-relative'>
        {choiceDegree.brandLogo ? (
          <div className='mt-lg-3 d-none d-lg-block'>
            <ImageComponent
              src={choiceDegree.brandLogo}
              altText={choiceDegree.brandName}
              width={210}
              height={60}
              layout='fixed'
              objectFit='contain'
            />
          </div>
        ) : (
          <h4
            className={`${styles[`header`]} ${styles[`header-brand-name`]} mt-lg-3 d-none d-lg-block mt-0`}
          >
            {choiceDegree.brandName}
          </h4>
        )}
        {prerequisitesContent && (
          <InfoPopup
            onClose={() => closePrerequisitesPopup()}
            cssClass={''}
            heading='Prerequisites'
          >
            {prerequisitesContent}
          </InfoPopup>
        )}
        {otherRequirementContent && (
          <InfoPopup
            onClose={() => closeOtherRequirementsPopup()}
            cssClass={''}
            heading='Additional Requirements'
          >
            {otherRequirementContent}
          </InfoPopup>
        )}
      </div>
    </div>
  );
}
